import styles from './Dimmer.module.scss'
import Loader from "@/components/UI/Loader/Loader";
import classNames from "classnames";

type Props = {
  loading?: boolean
  dark?: boolean
  onClick?: () => void
  className?: string
}

const Dimmer = ({loading, dark, onClick, className}: Props) => {
  return (
    <div onClick={onClick} className={classNames(styles.dimmer, dark && styles.dark, className)}>
      {loading && <Loader/> }
    </div>
  )
}

export default Dimmer;